import { gql } from "@apollo/client";

const GET_ASSOCIATED_SELLER = gql`
  query {
    getAssociatedSeller {
      data {
        email {
          address
        }
        firstName
        lastName
        phoneNumber
        isStripeSubscription
        setting {
          isReviewOrder
        }
      }
      status
      error
    }
  }
`;

export default GET_ASSOCIATED_SELLER;
